/* import __COLOCATED_TEMPLATE__ from './chat-description-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();